import { forwardRef, type Ref, type SVGProps } from "react";
const IconLegalFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.122 4.567a.91.91 0 0 0-.855-.7h-9.334v-.934C16.933 2.39 16.544 2 16 2s-.933.389-.933.933v.934H5.733a.91.91 0 0 0-.855.7l-2.793 9.285a2 2 0 0 0-.085.576V16c0 2.022 1.711 3.733 3.733 3.733h3.734c2.022 0 3.733-1.71 3.733-3.733v-1.577q0-.29-.082-.568L10.71 5.733h4.356l.008 22.4h-5.29s-1.02-.059-1.02.933c0 .991 1.02.933 1.02.933H22.23s.9-.039.9-.933c0-.895-.9-.934-.9-.934h-5.289l-.008-22.399h4.356L18.9 13.858a2 2 0 0 0-.08.562l-.003 1.597c0 2.023 1.694 3.716 3.716 3.716h3.734C28.289 19.733 30 18.023 30 16v-1.572a2 2 0 0 0-.085-.577zm-16.1 8.633H4.178l2.255-7.467h2.334zm14.545-7.467 2.255 7.467h-6.844l2.255-7.467z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLegalFilledSVG);
ForwardRef.displayName = "IconLegalFilled";
export { ForwardRef as IconLegalFilled };
